import { render, staticRenderFns } from "./UiAutocompleteSuggestion.vue?vue&type=template&id=9f42884e"
import script from "./UiAutocompleteSuggestion.vue?vue&type=script&lang=js"
export * from "./UiAutocompleteSuggestion.vue?vue&type=script&lang=js"
import style0 from "./UiAutocompleteSuggestion.vue?vue&type=style&index=0&id=9f42884e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports